import type React from 'react'
import type { JSX } from 'react'

import { COLOR, FIXED_INDENTS, LAYOUT } from 'vars/index'
import { TOALayoutSC } from './TOALayout.styled'

export interface ITOALayout {
  children?: React.ReactNode
  background?: COLOR
  paddings?: (FIXED_INDENTS | LAYOUT)[]
}

export const TOALayout = ({
  children,
  background = COLOR.TRANSPARENT,
  paddings = [FIXED_INDENTS.INDENT_70, LAYOUT.HorizontalPaddings],
}: ITOALayout): JSX.Element => (
  <TOALayoutSC background={background} paddings={paddings}>
    {children}
  </TOALayoutSC>
)
